import { Tutorial } from '../tutorial.model';

export const CATEGORIAS_TOUR: Tutorial = {
  id: 'categorias',
  rota: '/painel/categorias',
  passos: [
    {
      alvo: 'categorias.busca',
      titulo: 'Encontre a categoria pelo nome',
      corpo: 'Categorias organizam as receitas e despesas do jeito que você administra a empresa. Digite parte do nome para localizar uma categoria; a lista é atualizada depois da pausa na digitação.',
    },
    {
      alvo: 'categorias.filtros',
      titulo: 'Filtre por tipo e situação',
      corpo: 'Filtrar reúne Tipo, com Contas a pagar, Contas a receber ou Todos, e Situação, com Ativo, Inativo ou Todos. Os filtros alterados aparecem abaixo da pesquisa. Limpar volta aos dois tipos e às categorias ativas, mantendo o texto pesquisado.',
    },
    {
      alvo: 'categorias.tipo',
      titulo: 'Identifique onde a categoria é usada',
      corpo: 'Contas a pagar organiza saídas; Contas a receber organiza entradas. A categoria pode ser vinculada a contas contábeis do mesmo tipo. Esses vínculos são ajustados na edição da conta contábil ou em Gerenciar, na listagem do plano de contas.',
    },
    {
      alvo: 'categorias.nome',
      titulo: 'Organize a ordem da listagem',
      corpo: 'Use a seta ao lado de Nome para alternar a ordenação. O modelo prepara a organização financeira; as categorias de receitas que terão nota precisam também da configuração fiscal do serviço.',
    },
    {
      alvo: 'categorias.adicionar',
      titulo: 'Adicione uma categoria quando precisar',
      corpo: 'Adicionar abre uma janela com Nome e Tipo. Use um nome que faça sentido na sua gestão, como Despesas administrativas. Confira os campos aplicáveis e use Salvar para cadastrar; fechar a janela não salva.',
    },
    {
      alvo: 'categorias.visualizar',
      titulo: 'Consulte a categoria e suas contas contábeis',
      corpo: 'O botão de olho abre os detalhes da categoria: tipo, situação, contas contábeis vinculadas e datas de cadastro e última alteração. Você pode conferir os vínculos sem abrir a edição.',
    },
    {
      alvo: 'categorias.editar',
      titulo: 'Ajuste o cadastro pelo lápis',
      corpo: 'Abra a categoria das primeiras receitas pelo lápis. O guia dentro da janela acompanha categoria padrão, emissão de nota, código de tributação do serviço, NBS e código de tributação municipal. As orientações distinguem cada classificação conforme os anexos da NFS-e. Prepare os campos aplicáveis com a contabilidade e use Salvar.', corpoBase: 'Abra a categoria das primeiras receitas pelo lápis. A janela de edição reúne categoria padrão, emissão de nota, código de tributação do serviço, NBS e código de tributação municipal, classificados conforme os anexos da NFS-e. Prepare os campos aplicáveis com a contabilidade e use Salvar.',
    },
    {
      alvo: 'categorias.padrao',
      titulo: 'Entenda a indicação Padrão',
      corpo: 'Essa categoria é selecionada automaticamente ao criar uma conta a receber. A opção Categoria padrão fica na janela de cadastro ou edição das categorias de recebimento.',
    },
    {
      alvo: 'categorias.sem-ibscbs',
      titulo: 'Identifique as categorias sem classificação IBS/CBS',
      corpo: 'A marca Sem classificação IBS/CBS aparece nas categorias que emitem NFS-e e ainda não têm o indicador da operação, o CST ou a classificação tributária. Abra a categoria pelo lápis para preencher e confirme a classificação com a contabilidade.',
    },
    {
      alvo: 'categorias.situacao', alvoAlternativo: 'categorias.tabela', aguardarAlvo: true,
      titulo: 'Ative ou inative a categoria',
      corpo: 'O cadeado permite inativar uma categoria ativa ou reativar uma inativa, com confirmação. Para localizar as inativas, abra Filtrar e escolha a situação correspondente. Inativar mantém o cadastro salvo.',
    },
  ],
};
